import React from 'react';
import { PhotoIcon, TrashIcon } from '@heroicons/react/24/outline';

const LectureCard = ({ lecture, getThumbnailUrl, confirmDelete, handleLectureView, getBadgeText }) => {
  return (
    <div className="lecture-card">
      <div className="lecture-card-image">
        {lecture.thumbnail ? (
          <img 
            src={getThumbnailUrl(lecture.thumbnail)} 
            alt={lecture.title} 
            className="lecture-card-img" 
            crossOrigin="anonymous"
          />
        ) : (
          <div className="lecture-placeholder">
            <PhotoIcon className="lecture-placeholder-icon" />
          </div>
        )}
      </div>
      <div className="lecture-card-content">
        <div className="flex justify-between items-start gap-2">
          <h3 className="lecture-card-title flex-1">{lecture.title}</h3>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              confirmDelete(lecture.id);
            }}
            className="text-red-500 hover:text-red-700 p-1 rounded-full hover:bg-red-50 transition-colors"
            title="Delete Lecture"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        </div>
        <p className="lecture-card-description">{lecture.description}</p>
        <div className="lecture-card-meta">
          <span className="lecture-card-badge">
            {getBadgeText(lecture.contentType)}
          </span>
        </div>
        <button onClick={() => handleLectureView(lecture)} className="lecture-card-download-btn">
          View
        </button>
      </div>
    </div>
  );
};

export default LectureCard;
